import { useCallback, type ReactNode } from 'react';
import { useAuth } from '@/context/use-auth';
import { useQuery } from "convex/react";
import { api } from "../../../backend/convex/_generated/api";
import { CoinBalanceContext } from '@/context/coin-balance-context';

export function CoinBalanceProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  
  // Use Convex query to get balance - reactive and auto-updates
  const balanceData = useQuery(
    api.stripe.getCreditBalance,
    user ? { clerkId: user.id } : "skip"
  );

  const refreshBalance = useCallback(() => {
    // Convex queries auto-refresh, but this function is kept for API compatibility
    // In the future, we could force a refetch here if needed
  }, []);

  const balance = balanceData?.balance ?? null;
  const isLoading = !!user && balanceData === undefined;

  return (
    <CoinBalanceContext.Provider value={{ balance, isLoading, refreshBalance }}>
      {children}
    </CoinBalanceContext.Provider>
  );
}
